import styled from 'styled-components/macro'
import CarouselComponent from '@brainhubeu/react-carousel'

const Carousel = styled(CarouselComponent)`
  position: relative;
  .BrainhubCarouselItem {
    width: 100%;
    img {
      width: 100%;
    }
  }
`

const DotsWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 5px 0;
`

const Dot = styled.div`
  outline: 0;
  padding: 10px;
  border: none;
  opacity: ${props => (props.active ? 1 : 0.3)};
  font-size: 0;
  cursor: pointer;
  -webkit-appearance: none;

  &:before {
    content: '';
    display: block;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    padding: 0;
    border: none;
    background: #000;
  }
`

const ThumbnailsWrapper = styled.div`
  position: absolute;
  top: 0;

  max-height: 400px;
  overflow: auto;
`

const ThumbnailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  top: 0;
  overflow: auto;
`

const Thumbnail = styled.img`
  width: 50px;
  height: 50px;
  margin-bottom: 16px;
  opacity: ${props => (props.active ? 1 : 0.5)};
  &:hover {
    transform: scale(1.1);
    opacity: 1;
  }
`

export { Carousel, DotsWrapper, Dot, ThumbnailsWrapper, Thumbnail, ThumbnailsContainer }
